import { LitElement, html, css, TemplateResult } from 'lit';
import * as uuid from "uuid";
export class BootStrapBase extends LitElement {
    //remove shadowroot for bootstrap access to work correctly
    createRenderRoot() {
        return this;
    }

    render() {
        return html`
        <slot></slot>
      `;
    }

    attributeTrue(name: string) {
        if (!this.hasAttribute(name))
            return false;
        else {
            const attr = this.getAttribute(name);
            return attr == undefined || attr !== "false";
        }

    }
}


export class BootStrapText extends BootStrapBase {
    private _idUnique: string = uuid.v4();
    label?: string;
    value?: string;
    static get properties() {
        return {
            "label": { type: String },
            "value": { type: String }
        };
    }
    getId(): string {
        return `text${this._idUnique}`;
    }
    render() {
        const _id = this.getId();
    
        return html`
        <div class="form-floating">
            <input type="text" id=${_id} class="form-control" .value=${this.value} readonly aria-readonly>
            <label for=${_id}>${this.label}</label>
        </div>
      `;

    }

}


export class Paginator extends BootStrapBase {
    static get properties() {
        return {
            "data-index": { type: Number },
            "data-count": { type: Number }
        };
    }
    render() {
        let currentPage = parseInt(this.dataset.index ?? "0");
        let pageCount = parseInt(this.dataset.count ?? "0");

        const visiblePages = 11;
        const pageDeductor = 5;
        let firstDisplayPage = currentPage - pageDeductor;
        if (firstDisplayPage < 1) firstDisplayPage = 1;
        let lastDisplayPage = firstDisplayPage + visiblePages - 1;
        if (lastDisplayPage > pageCount) lastDisplayPage = pageCount;

        if (lastDisplayPage === pageCount && lastDisplayPage - firstDisplayPage + 1 < visiblePages)
            firstDisplayPage = Math.max(1, lastDisplayPage - visiblePages + 1);
        if (firstDisplayPage === 1 && lastDisplayPage - firstDisplayPage + 1 < visiblePages)
            lastDisplayPage = Math.min(pageCount, firstDisplayPage + visiblePages - 1);


        const includeSkipToFirst = firstDisplayPage > 1;
        const includeSkipToLast = lastDisplayPage < pageCount - 1;

        const clickEvent = (e: Event) => {
            e.preventDefault();
            const strPage = (e.target as HTMLUListElement).textContent?.toLowerCase();
            if (strPage === "prev")
                currentPage--;
            else if (strPage === "next")
                currentPage++;
            else if (strPage === "last")
                currentPage = pageCount;
            else if (strPage === "first")
                currentPage = 1;
            else
                currentPage = parseInt(strPage ?? "0");

            //handle accidental overflows
            currentPage = Math.min(pageCount, Math.max(1, currentPage));
            let event = new CustomEvent('page-change', {
                detail: {
                    index: currentPage - 1
                }
            });
            this.dispatchEvent(event);



        };

        const pages = (): Array<TemplateResult> => {
            const pageResult: Array<TemplateResult> = [];
            for (let i = firstDisplayPage; i <= lastDisplayPage; i++) {
                if (i === currentPage) {
                    pageResult.push(html`<li class="page-item active"><span class="page-link">${i}</span></li>`);
                } else {
                    pageResult.push(html`<li class="page-item"><a class="page-link" href="#" @click=${clickEvent}>${i}</a></li>`);
                }
            }
            return pageResult;

        };

        return html`
            <nav aria-label="Page navigation">
                <ul class="pagination pagination-sm justify-content-center">
                    <li class=${`page-item ${!includeSkipToFirst ? "disabled" : "" }`}><a class="page-link" href="#"
                            @click=${clickEvent}>First</a>
                    </li>
                    <li class=${`page-item ${currentPage===1 ? "disabled" : "" }`}><a class="page-link" href="#" rel="prev"
                            @click=${clickEvent}>Prev</a>
                    </li>
                    ${pages()}
                    <li class=${`page-item ${currentPage===pageCount ? "disabled" : "" }`}><a class="page-link" href="#" rel="prev"
                            @click=${clickEvent}>Next</a></li>
                    <li class=${`page-item ${!includeSkipToLast ? "disabled" : "" }`}><a class="page-link" href="#"
                            @click=${clickEvent}>Last</a></li>
                </ul>
            </nav>`;


    }

}
export function registerBootstrapComponent() {
    customElements.define('bs-paginator', Paginator);
    customElements.define('bs-text', BootStrapText);
}
